export const purchasedWithinOptions = [
  { value: '104', label: 'Last 2 Years' },
  { value: '52', label: 'Last Year' },
  { value: '26', label: 'Last 6 Months' },
  { value: '13', label: 'Last Quarter' },
  { value: '4', label: 'Last Month' },
  { value: '1', label: 'Last Week' },
];

export const listDropDownDefault = { value: 'all', label: 'All Lists' };


export const ingredientsSearchTabs = {
  PURCHASE_HISTORY_TAB: { title: 'Purchase History', key: 'purchaseHistoryTab', isCanadaRestricted: true, isIngredientReplcement: true },
  PREVIOUSLY_USED_TAB: { title: 'Previously Used', key: 'previouslyUsedTab', isCanadaRestricted: true, isIngredientReplcement: true },
  ITEM_LISTS_TAB: { title: 'Item Lists', key: 'itemListsTab', isCanadaRestricted: true, isIngredientReplcement: true },
  BATCH_RECIPES_TAB: { title: 'Batch Recipes', key: 'batchRecipesTab', isCanadaRestricted: false, isIngredientReplcement: false },
  CUSTOM_INGREDIENTS_TAB: { title: 'Custom Ingredients', key: 'customIngredientsTab', isCanadaRestricted: false, isIngredientReplcement: true },
  FULL_PRODUCT_CATALOG_TAB: { title: 'Product Catalog', key: 'fullProductCatalogTab', isCanadaRestricted: true, isIngredientReplcement: true },
};

export const syscoBrandMapping = {
  [ingredientsSearchTabs.PURCHASE_HISTORY_TAB.key]: true,
  [ingredientsSearchTabs.PREVIOUSLY_USED_TAB.key]: true,
  [ingredientsSearchTabs.ITEM_LISTS_TAB.key]: true,
  [ingredientsSearchTabs.FULL_PRODUCT_CATALOG_TAB.key]: true,
  [ingredientsSearchTabs.BATCH_RECIPES_TAB.key]: false,
  [ingredientsSearchTabs.CUSTOM_INGREDIENTS_TAB.key]: false,
};

export const filterSectionTypes = {
  DROP_DOWN: 'dd',
  CHECK_BOXES: 'cb',
  RADIO_BUTTONS: 'rb',
};

export const ingredientsSearchFilters = {
  PURCHASED_WITHIN: { id: 'PURCHASED_WITHIN', name: 'Purchased Within' },
  LIST_NAME: { id: 'LIST_NAME', name: 'List' },
  CATEGORY: { id: 'CATEGORY', name: 'Category' },
  BRAND: { id: 'BRAND', name: 'Brand' },
  PACK_SIZE: { id: 'PACK_SIZE', name: 'Pack/Size' },
  STOCK_TYPE: { id: 'STOCK_TYPE', name: 'Stock Type' },
};

export const batchRecipesTabColumns = [
  { header: 'name', key: 'name', maxWidth: 250 },
  { header: 'total cost', key: 'totalCost', maxWidth: 110 },
  { header: 'cost per unit', key: 'cost', maxWidth: 120 },
  { header: 'yield', key: 'yield', maxWidth: 80 },
  { header: 'used in', key: 'usedInRecipes', maxWidth: 80 },
];

export const previousUsedTabColumns = [
  { header: 'name', key: 'name', maxWidth: 250 },
  { header: 'supc', key: 'supc', maxWidth: 80 },
  { header: 'brand', key: 'brand', maxWidth: 110 },
  { header: 'pack/size', key: 'packSize', maxWidth: 100 },
  { header: 'cost', key: 'cost', maxWidth: 100 },
  { header: 'used in', key: 'usedInRecipes', maxWidth: 110 },
];

export const columns = [
  { header: 'name', key: 'name', maxWidth: 250 },
  { header: 'supc', key: 'supc', maxWidth: 80 },
  { header: 'brand', key: 'brand', maxWidth: 110 },
  { header: 'pack/size', key: 'packSize', maxWidth: 100 },
  { header: 'cost', key: 'cost', maxWidth: 100 },
];

export const customIngredientsTabColumns = [
  { header: 'name', key: 'name', maxWidth: 250 },
  { header: 'brand', key: 'brand', maxWidth: 110 },
  { header: 'cost per unit', key: 'cost', maxWidth: 120 },
  { header: 'used in', key: 'usedInRecipes', maxWidth: 110 },
];

export const ingredientTabId = 'ingredient-tab-bar';
export const selectColumnId = 'selectButton';

// Error messages
export const saveIngredientFailureMessage = 'The system encountered an error while saving the ingredients.'
  + '  Please try again.\n\nIf you receive this message multiple times, please contact your system administrator.';
export const sameIngredientExistsMessage = 'Ingredient with same name and brand already exists';
export const potentialCircularDependencyMessage = 'This batch recipe cannot be added as an ingredient';
export const errorWhileCheckingCircularDependencyMessage = 'The system encountered an error while checking for circular dependencies';

// No data messages
export const noDataMessage = 'No Data Available';
export const noDataMessageProductCatalog = 'Please refine your request by searching for a specific ingredient';
export const noListsMessage = 'No Lists exist in Sysco Shop for this customer. The Lists will be exposed in Sysco Studio once they are defined';